import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AdditionalAttributes } from '../../core/models/additional-attributes.model';
import { ProgressBar } from '../../core/models/progress-bar.model';
import { Services } from '../../core/models/services.model';
import { Team } from '../../core/models/team.model';

@Injectable({ providedIn: 'root' })
export class ShellMessageService {
  // progress bar shell initialize
  private progressBarShellInitializeSubject = new Subject<any>();
  getProgressBarShellInitializeSubject$ =
    this.progressBarShellInitializeSubject.asObservable();
  sendProgressBarShellInitializeMessage(
    progressBarShellInitializeMessage: ProgressBar,
  ) {
    this.progressBarShellInitializeSubject.next({
      progressBarShellData: progressBarShellInitializeMessage,
    });
  }


  // team shell initialize
  private teamShellInitializeSubject = new Subject<any>();
  getTeamShellInitializeSubject$ =
    this.teamShellInitializeSubject.asObservable();
  sendTeamShellInitializeMessage(teamShellInitializeMessage: Team) {
    this.teamShellInitializeSubject.next({
      teamShellData: teamShellInitializeMessage,
    });
  }

  // services shell initialize
  private servicesShellInitializeSubject = new Subject<any>();
  getservicesShellInitializeSubject$ =
    this.servicesShellInitializeSubject.asObservable();
  sendServicesAttributesShellInitializeSubject(
    servicesShellInitializeMessage: Services,
  ) {
    this.servicesShellInitializeSubject.next({
      servicesShellData: servicesShellInitializeMessage,
    });
  }

  // additional attributes shell initialize
  private additionalAttributesShellInitializeSubject = new Subject<any>();
  getadditionalAttributesShellInitializeSubject$ =
    this.additionalAttributesShellInitializeSubject.asObservable();
  sendadditionalAttributesShellInitializeSubject(
    additionalAttributesShellInitializeMessage: AdditionalAttributes,
  ) {
    this.additionalAttributesShellInitializeSubject.next({
      additionalAttributesShellData: additionalAttributesShellInitializeMessage,
    });
  }

  // hide drop down (emd, em, currencies, primary services, etc...) when another drop down is enable\
  private dropDownHideSubject = new Subject<any>();
  getDropDownHideSubject$ = this.dropDownHideSubject.asObservable();
  sendDropDownHideSubject() {
    this.dropDownHideSubject.next(null);
  }

  //save opportunity services
  private saveOpportunityServicesSubject = new Subject<any>();
  getsaveOpportunityServicesSubject$ =
    this.saveOpportunityServicesSubject.asObservable();
  sendsaveOpportunityServicesSubject(opportunityServicesDataFromShell: any) {
    this.saveOpportunityServicesSubject.next({
      opportunityServicesData: opportunityServicesDataFromShell,
    });
  }

  // disable Change Order Opportunity Fields
  private disableChangeOrderSubject = new Subject<any>();
  getChangeOrderDisableSubject$ = this.disableChangeOrderSubject.asObservable();
  sendChangeOrderDisableMessage() {
    this.disableChangeOrderSubject.next(null);
  }

  // required fields error display in form
  private requiredFieldsErrorDisplaySubject = new Subject<any>();
  getRequiredFieldsErrorDisplaySubject$ =
    this.requiredFieldsErrorDisplaySubject.asObservable();
  sendRequiredFieldsErrorDisplayMessage(opportunityStatus: any) {
    this.requiredFieldsErrorDisplaySubject.next({
      opportunityStatus: opportunityStatus,
    });
  }

  // closed status disable fields
  private closedStatusAndDisableControlsSubject = new Subject<any>();
  getClosedStatusAndDisableControlsSubject$ =
    this.closedStatusAndDisableControlsSubject.asObservable();
  sendClosedStatusAndDisableControlsMessage() {
    this.closedStatusAndDisableControlsSubject.next(null);
  }

  // disable field when there is subbuget activated
  private disableFieldsWhenActivatedSubBugetSubject = new Subject<any>();
  getDisableFieldsWhenActivatedSubBugetSubject$ =
    this.disableFieldsWhenActivatedSubBugetSubject.asObservable();
  sendDisableFieldsWhenActivatedSubBugetMessage() {
    this.disableFieldsWhenActivatedSubBugetSubject.next(null);
  }

  // request amount mismatch from opportunity service
  private requestOpportunityAmountMismatchSubject = new Subject<any>();
  getRequestOpportunityAmountMismatchSubject$ =
    this.requestOpportunityAmountMismatchSubject.asObservable();
  sendRequestOpportunityAmountMismatchMessage(
    isRevenueScheduleRequiredMessage: any,
  ) {
    this.requestOpportunityAmountMismatchSubject.next({
      isRevenueScheduleRequiredData: isRevenueScheduleRequiredMessage,
    });
  }

  // get amount mismatch
  private opportunityAmountMismatchSubject = new Subject<any>();
  getOpportunityAmountMismatchSubject$ =
    this.opportunityAmountMismatchSubject.asObservable();
  sendOpportunityAmountMismatchMessage(isAmtMisMatchedMessage: any) {
    this.opportunityAmountMismatchSubject.next({
      isAmtMisMatchedData: isAmtMisMatchedMessage,
    });
  }

  //send previous opportunity stage to be changed
  private oppStagePreviousSubject = new Subject<any>();
  getoppStagePreviousSubject$ = this.oppStagePreviousSubject.asObservable();
  sendOppStagePreviousMessage(stageId: any) {
    this.oppStagePreviousSubject.next({ stageId: stageId });
  }

  // send currency code to service sub shell section
  private updateOpportunityCurrencySubject = new Subject<any>();
  getUpdateOpportunityCurrencySubject$ =
    this.updateOpportunityCurrencySubject.asObservable();
  sendUpdateOpportunityCurrencySubjectMessage(updatedOpportunityCurrency: any) {
    this.updateOpportunityCurrencySubject.next({
      updatedOpportunityCurrencyData: updatedOpportunityCurrency,
    });
  }

  // change some controls to require validation
  private updateControlsToBeRequiredSubject = new Subject<any>();
  getUpdateControlsToBeRequiredSubject$ =
    this.updateControlsToBeRequiredSubject.asObservable();
  sendUpdateControlsToBeRequiredSubjectMessage(opportunityStatus: any) {
    this.updateControlsToBeRequiredSubject.next({
      opportunityStatus: opportunityStatus,
    });
  }

  // send message notify when opportunity service is successfully saved
  private opportunityServiceSuccessfullySavedSubject = new Subject<any>();
  getOpportunityServiceSuccessfullySavedSubject$ =
    this.opportunityServiceSuccessfullySavedSubject.asObservable();
  sendOpportunityServiceSuccessfullySavedMessage() {
    this.opportunityServiceSuccessfullySavedSubject.next({});
  }

  private updateShellChildAfterSavedSubject = new Subject<any>();
  getUpdateShellChildAfterSavedSubject$ =
    this.updateShellChildAfterSavedSubject.asObservable();
  sendUpdateShellChildAfterSavedMessage(transferObject: any) {
    this.updateShellChildAfterSavedSubject.next({
      name: transferObject.nameData,
      opportunityStatus: transferObject.opportunityStatus,
      servicesData: transferObject.servicesData,
    });
  }

  //used for primary key buyer
  private clientIdSubject = new Subject<any>();
  getClientIdSubject$ = this.clientIdSubject.asObservable();
  sendClientIdSubject(shellInfo: any) {
    this.clientIdSubject.next({ shellInfo: shellInfo });
  }
}
